/* tslint:disable */
/* eslint-disable */
/**
 * LPPSWebApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { formatDateOnly, mapValues } from '../runtime';
import type { PriceStatus } from './PriceStatus';
import {
    PriceStatusFromJSON,
    PriceStatusFromJSONTyped,
    PriceStatusToJSON,
    PriceStatusToJSONTyped,
} from './PriceStatus';
import type { LaunchStatusHy } from './LaunchStatusHy';
import {
    LaunchStatusHyFromJSON,
    LaunchStatusHyFromJSONTyped,
    LaunchStatusHyToJSON,
    LaunchStatusHyToJSONTyped,
} from './LaunchStatusHy';

/**
 * 
 * @export
 * @interface SimulationData
 */
export interface SimulationData {
    /**
     * 
     * @type {string}
     * @memberof SimulationData
     */
    primaryKey?: string | null;
    /**
     * 
     * @type {number}
     * @memberof SimulationData
     */
    planningDate?: number;
    /**
     * 
     * @type {number}
     * @memberof SimulationData
     */
    plannedYear?: number;
    /**
     * 
     * @type {number}
     * @memberof SimulationData
     */
    priceUnitId?: number;
    /**
     * 
     * @type {number}
     * @memberof SimulationData
     */
    productId?: number;
    /**
     * 
     * @type {string}
     * @memberof SimulationData
     */
    productName?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof SimulationData
     */
    license?: boolean;
    /**
     * 
     * @type {number}
     * @memberof SimulationData
     */
    themeId?: number;
    /**
     * 
     * @type {string}
     * @memberof SimulationData
     */
    readonly themeIdAsString: string;
    /**
     * 
     * @type {string}
     * @memberof SimulationData
     */
    themeName: string | null;
    /**
     * 
     * @type {number}
     * @memberof SimulationData
     */
    groupId?: number;
    /**
     * 
     * @type {string}
     * @memberof SimulationData
     */
    readonly groupIdAsString: string;
    /**
     * 
     * @type {string}
     * @memberof SimulationData
     */
    groupName: string | null;
    /**
     * 
     * @type {number}
     * @memberof SimulationData
     */
    productClassLevelOneId?: number;
    /**
     * 
     * @type {string}
     * @memberof SimulationData
     */
    productClassLevelOneName?: string | null;
    /**
     * 
     * @type {number}
     * @memberof SimulationData
     */
    productClassLevelTwoId?: number;
    /**
     * 
     * @type {string}
     * @memberof SimulationData
     */
    productClassLevelTwoName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SimulationData
     */
    productAudience?: string | null;
    /**
     * 
     * @type {LaunchStatusHy}
     * @memberof SimulationData
     */
    launchStatus?: LaunchStatusHy;
    /**
     * 
     * @type {string}
     * @memberof SimulationData
     */
    currency?: string | null;
    /**
     * 
     * @type {number}
     * @memberof SimulationData
     */
    currencyDecimals: number;
    /**
     * 
     * @type {string}
     * @memberof SimulationData
     */
    localLeadCurrency: string | null;
    /**
     * 
     * @type {number}
     * @memberof SimulationData
     */
    localLeadCurrencyDecimals: number;
    /**
     * 
     * @type {string}
     * @memberof SimulationData
     */
    globalLeadCurrency: string | null;
    /**
     * 
     * @type {number}
     * @memberof SimulationData
     */
    globalLeadCurrencyDecimals: number;
    /**
     * 
     * @type {number}
     * @memberof SimulationData
     */
    globalLeadIer?: number;
    /**
     * 
     * @type {string}
     * @memberof SimulationData
     */
    comment?: string | null;
    /**
     * 
     * @type {PriceStatus}
     * @memberof SimulationData
     */
    priceStatus?: PriceStatus;
    /**
     * 
     * @type {number}
     * @memberof SimulationData
     */
    rrp?: number;
    /**
     * 
     * @type {number}
     * @memberof SimulationData
     */
    lp?: number;
    /**
     * 
     * @type {number}
     * @memberof SimulationData
     */
    rm?: number;
    /**
     * 
     * @type {number}
     * @memberof SimulationData
     */
    vat?: number;
    /**
     * 
     * @type {number}
     * @memberof SimulationData
     */
    functionalDiscount?: number;
    /**
     * 
     * @type {number}
     * @memberof SimulationData
     */
    salesDiscount?: number;
    /**
     * 
     * @type {number}
     * @memberof SimulationData
     */
    tradeContributionDiscount?: number;
    /**
     * 
     * @type {number}
     * @memberof SimulationData
     */
    localLeadCurrencyRate?: number;
    /**
     * 
     * @type {number}
     * @memberof SimulationData
     */
    globalLeadCurrencyRate?: number;
    /**
     * 
     * @type {number}
     * @memberof SimulationData
     */
    localLeadRrp?: number;
    /**
     * 
     * @type {number}
     * @memberof SimulationData
     */
    localLeadLp?: number;
    /**
     * 
     * @type {number}
     * @memberof SimulationData
     */
    localLeadRm?: number;
    /**
     * 
     * @type {number}
     * @memberof SimulationData
     */
    localLeadVat?: number;
    /**
     * 
     * @type {number}
     * @memberof SimulationData
     */
    localLeadFunctionalDiscount?: number;
    /**
     * 
     * @type {number}
     * @memberof SimulationData
     */
    localLeadSalesDiscount?: number;
    /**
     * 
     * @type {number}
     * @memberof SimulationData
     */
    localLeadTradeContributionDiscount?: number;
    /**
     * 
     * @type {number}
     * @memberof SimulationData
     */
    globalLeadRrp?: number;
    /**
     * 
     * @type {number}
     * @memberof SimulationData
     */
    globalLeadLp?: number;
    /**
     * 
     * @type {number}
     * @memberof SimulationData
     */
    globalLeadRm?: number;
    /**
     * 
     * @type {number}
     * @memberof SimulationData
     */
    globalLeadVat?: number;
    /**
     * 
     * @type {number}
     * @memberof SimulationData
     */
    globalLeadFunctionalDiscount?: number;
    /**
     * 
     * @type {number}
     * @memberof SimulationData
     */
    globalLeadSalesDiscount?: number;
    /**
     * 
     * @type {number}
     * @memberof SimulationData
     */
    globalLeadTradeContributionDiscount?: number;
    /**
     * 
     * @type {number}
     * @memberof SimulationData
     */
    listPriceFmcTargetFactor?: number;
    /**
     * 
     * @type {number}
     * @memberof SimulationData
     */
    aboveThresholdMin?: number;
    /**
     * 
     * @type {number}
     * @memberof SimulationData
     */
    aboveThresholdMax?: number;
    /**
     * 
     * @type {number}
     * @memberof SimulationData
     */
    belowThresholdMin?: number;
    /**
     * 
     * @type {number}
     * @memberof SimulationData
     */
    belowThresholdMax?: number;
    /**
     * 
     * @type {number}
     * @memberof SimulationData
     */
    thresholdPrice?: number;
    /**
     * 
     * @type {number}
     * @memberof SimulationData
     */
    forecastedDemand?: number;
    /**
     * 
     * @type {number}
     * @memberof SimulationData
     */
    fmcCostPerPiece?: number;
    /**
     * 
     * @type {number}
     * @memberof SimulationData
     */
    productGroupId?: number;
    /**
     * 
     * @type {string}
     * @memberof SimulationData
     */
    productGroupName?: string | null;
    /**
     * 
     * @type {number}
     * @memberof SimulationData
     */
    productCategoryId?: number;
    /**
     * 
     * @type {string}
     * @memberof SimulationData
     */
    productCategoryName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SimulationData
     */
    developmentOwnershipId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SimulationData
     */
    developmentOwnershipName?: string | null;
    /**
     * 
     * @type {number}
     * @memberof SimulationData
     */
    productCompositionId?: number;
    /**
     * 
     * @type {string}
     * @memberof SimulationData
     */
    productCompositionName?: string | null;
    /**
     * 
     * @type {number}
     * @memberof SimulationData
     */
    superSegmentId?: number;
    /**
     * 
     * @type {string}
     * @memberof SimulationData
     */
    superSegmentName?: string | null;
    /**
     * 
     * @type {number}
     * @memberof SimulationData
     */
    themeCategoryId?: number;
    /**
     * 
     * @type {string}
     * @memberof SimulationData
     */
    readonly themeCategoryIdAsString: string;
    /**
     * 
     * @type {string}
     * @memberof SimulationData
     */
    themeCategoryName?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof SimulationData
     */
    isRareItem?: boolean;
    /**
     * 
     * @type {Date}
     * @memberof SimulationData
     */
    localLaunchDate?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof SimulationData
     */
    localExitDate?: Date | null;
    /**
     * 
     * @type {number}
     * @memberof SimulationData
     */
    dominantMaterialId?: number | null;
    /**
     * 
     * @type {number}
     * @memberof SimulationData
     */
    boxSizeId?: number | null;
    /**
     * 
     * @type {string}
     * @memberof SimulationData
     */
    boxSizeName?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof SimulationData
     */
    businessToBusinessLaunchDate?: Date | null;
    /**
     * 
     * @type {boolean}
     * @memberof SimulationData
     */
    directToConsumerLifelong?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof SimulationData
     */
    sizeDimension?: string | null;
    /**
     * 
     * @type {number}
     * @memberof SimulationData
     */
    pieceCount?: number | null;
    /**
     * 
     * @type {number}
     * @memberof SimulationData
     */
    smartPlayId?: number | null;
    /**
     * 
     * @type {string}
     * @memberof SimulationData
     */
    smartPlayName?: string | null;
    /**
     * 
     * @type {number}
     * @memberof SimulationData
     */
    playTypeId?: number | null;
    /**
     * 
     * @type {string}
     * @memberof SimulationData
     */
    playTypeName?: string | null;
    /**
     * 
     * @type {number}
     * @memberof SimulationData
     */
    topThemeId?: number | null;
    /**
     * 
     * @type {string}
     * @memberof SimulationData
     */
    topThemeName?: string | null;
    /**
     * 
     * @type {number}
     * @memberof SimulationData
     */
    valueBasedPrice?: number | null;
    /**
     * 
     * @type {number}
     * @memberof SimulationData
     */
    previousValidFrom?: number;
    /**
     * 
     * @type {number}
     * @memberof SimulationData
     */
    previousRrp?: number;
    /**
     * 
     * @type {number}
     * @memberof SimulationData
     */
    previousLp?: number;
    /**
     * 
     * @type {number}
     * @memberof SimulationData
     */
    previousRm?: number;
    /**
     * 
     * @type {number}
     * @memberof SimulationData
     */
    previousVat?: number;
    /**
     * 
     * @type {number}
     * @memberof SimulationData
     */
    previousLocalLeadRrp?: number;
    /**
     * 
     * @type {number}
     * @memberof SimulationData
     */
    previousLocalLeadLp?: number;
    /**
     * 
     * @type {number}
     * @memberof SimulationData
     */
    previousLocalLeadRm?: number;
    /**
     * 
     * @type {number}
     * @memberof SimulationData
     */
    previousLocalLeadVat?: number;
    /**
     * 
     * @type {number}
     * @memberof SimulationData
     */
    previousGlobalLeadRrp?: number;
    /**
     * 
     * @type {number}
     * @memberof SimulationData
     */
    previousGlobalLeadLp?: number;
    /**
     * 
     * @type {number}
     * @memberof SimulationData
     */
    previousGlobalLeadRm?: number;
    /**
     * 
     * @type {number}
     * @memberof SimulationData
     */
    previousGlobalLeadVat?: number;
    /**
     * 
     * @type {number}
     * @memberof SimulationData
     */
    previousLocalLeadCurrencyRate?: number;
    /**
     * 
     * @type {number}
     * @memberof SimulationData
     */
    previousGlobalLeadCurrencyRate?: number;
    /**
     * 
     * @type {number}
     * @memberof SimulationData
     */
    previousForecastedDemand?: number;
    /**
     * 
     * @type {number}
     * @memberof SimulationData
     */
    previousFmcCostPerPiece?: number;
    /**
     * 
     * @type {number}
     * @memberof SimulationData
     */
    previousFunctionalDiscount?: number;
    /**
     * 
     * @type {number}
     * @memberof SimulationData
     */
    previousSalesDiscount?: number;
    /**
     * 
     * @type {number}
     * @memberof SimulationData
     */
    previousTradeContributionDiscount?: number;
    /**
     * 
     * @type {number}
     * @memberof SimulationData
     */
    previousLocalLeadFunctionalDiscount?: number;
    /**
     * 
     * @type {number}
     * @memberof SimulationData
     */
    previousLocalLeadSalesDiscount?: number;
    /**
     * 
     * @type {number}
     * @memberof SimulationData
     */
    previousLocalLeadTradeContributionDiscount?: number;
    /**
     * 
     * @type {number}
     * @memberof SimulationData
     */
    previousGlobalLeadFunctionalDiscount?: number;
    /**
     * 
     * @type {number}
     * @memberof SimulationData
     */
    previousGlobalLeadSalesDiscount?: number;
    /**
     * 
     * @type {number}
     * @memberof SimulationData
     */
    previousGlobalLeadTradeContributionDiscount?: number;
    /**
     * 
     * @type {number}
     * @memberof SimulationData
     */
    futureValidFrom?: number;
    /**
     * 
     * @type {number}
     * @memberof SimulationData
     */
    futureRrp?: number;
    /**
     * 
     * @type {number}
     * @memberof SimulationData
     */
    futureLp?: number;
    /**
     * 
     * @type {number}
     * @memberof SimulationData
     */
    futureRm?: number;
    /**
     * 
     * @type {number}
     * @memberof SimulationData
     */
    futureVat?: number;
    /**
     * 
     * @type {number}
     * @memberof SimulationData
     */
    nearestFutureModifiedLp?: number | null;
    /**
     * 
     * @type {Date}
     * @memberof SimulationData
     */
    nearestFutureModifiedLpValidFrom?: Date | null;
    /**
     * 
     * @type {number}
     * @memberof SimulationData
     */
    initialRrp?: number | null;
    /**
     * 
     * @type {number}
     * @memberof SimulationData
     */
    initialLp?: number | null;
    /**
     * 
     * @type {number}
     * @memberof SimulationData
     */
    initialRm?: number | null;
    /**
     * 
     * @type {number}
     * @memberof SimulationData
     */
    versionRrp?: number | null;
    /**
     * 
     * @type {number}
     * @memberof SimulationData
     */
    versionLp?: number | null;
    /**
     * 
     * @type {number}
     * @memberof SimulationData
     */
    versionRm?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof SimulationData
     */
    useRrp?: boolean;
}



/**
 * Check if a given object implements the SimulationData interface.
 */
export function instanceOfSimulationData(value: object): value is SimulationData {
    if (!('themeIdAsString' in value) || value['themeIdAsString'] === undefined) return false;
    if (!('themeName' in value) || value['themeName'] === undefined) return false;
    if (!('groupIdAsString' in value) || value['groupIdAsString'] === undefined) return false;
    if (!('groupName' in value) || value['groupName'] === undefined) return false;
    if (!('currencyDecimals' in value) || value['currencyDecimals'] === undefined) return false;
    if (!('localLeadCurrency' in value) || value['localLeadCurrency'] === undefined) return false;
    if (!('localLeadCurrencyDecimals' in value) || value['localLeadCurrencyDecimals'] === undefined) return false;
    if (!('globalLeadCurrency' in value) || value['globalLeadCurrency'] === undefined) return false;
    if (!('globalLeadCurrencyDecimals' in value) || value['globalLeadCurrencyDecimals'] === undefined) return false;
    if (!('themeCategoryIdAsString' in value) || value['themeCategoryIdAsString'] === undefined) return false;
    return true;
}

export function SimulationDataFromJSON(json: any): SimulationData {
    return SimulationDataFromJSONTyped(json, false);
}

export function SimulationDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): SimulationData {
    if (json == null) {
        return json;
    }
    return {
        
        'primaryKey': json['primaryKey'] == null ? undefined : json['primaryKey'],
        'planningDate': json['planningDate'] == null ? undefined : json['planningDate'],
        'plannedYear': json['plannedYear'] == null ? undefined : json['plannedYear'],
        'priceUnitId': json['priceUnitId'] == null ? undefined : json['priceUnitId'],
        'productId': json['productId'] == null ? undefined : json['productId'],
        'productName': json['productName'] == null ? undefined : json['productName'],
        'license': json['license'] == null ? undefined : json['license'],
        'themeId': json['themeId'] == null ? undefined : json['themeId'],
        'themeIdAsString': json['themeIdAsString'],
        'themeName': json['themeName'],
        'groupId': json['groupId'] == null ? undefined : json['groupId'],
        'groupIdAsString': json['groupIdAsString'],
        'groupName': json['groupName'],
        'productClassLevelOneId': json['productClassLevelOneId'] == null ? undefined : json['productClassLevelOneId'],
        'productClassLevelOneName': json['productClassLevelOneName'] == null ? undefined : json['productClassLevelOneName'],
        'productClassLevelTwoId': json['productClassLevelTwoId'] == null ? undefined : json['productClassLevelTwoId'],
        'productClassLevelTwoName': json['productClassLevelTwoName'] == null ? undefined : json['productClassLevelTwoName'],
        'productAudience': json['productAudience'] == null ? undefined : json['productAudience'],
        'launchStatus': json['launchStatus'] == null ? undefined : LaunchStatusHyFromJSON(json['launchStatus']),
        'currency': json['currency'] == null ? undefined : json['currency'],
        'currencyDecimals': json['currencyDecimals'],
        'localLeadCurrency': json['localLeadCurrency'],
        'localLeadCurrencyDecimals': json['localLeadCurrencyDecimals'],
        'globalLeadCurrency': json['globalLeadCurrency'],
        'globalLeadCurrencyDecimals': json['globalLeadCurrencyDecimals'],
        'globalLeadIer': json['globalLeadIer'] == null ? undefined : json['globalLeadIer'],
        'comment': json['comment'] == null ? undefined : json['comment'],
        'priceStatus': json['priceStatus'] == null ? undefined : PriceStatusFromJSON(json['priceStatus']),
        'rrp': json['rrp'] == null ? undefined : json['rrp'],
        'lp': json['lp'] == null ? undefined : json['lp'],
        'rm': json['rm'] == null ? undefined : json['rm'],
        'vat': json['vat'] == null ? undefined : json['vat'],
        'functionalDiscount': json['functionalDiscount'] == null ? undefined : json['functionalDiscount'],
        'salesDiscount': json['salesDiscount'] == null ? undefined : json['salesDiscount'],
        'tradeContributionDiscount': json['tradeContributionDiscount'] == null ? undefined : json['tradeContributionDiscount'],
        'localLeadCurrencyRate': json['localLeadCurrencyRate'] == null ? undefined : json['localLeadCurrencyRate'],
        'globalLeadCurrencyRate': json['globalLeadCurrencyRate'] == null ? undefined : json['globalLeadCurrencyRate'],
        'localLeadRrp': json['localLeadRrp'] == null ? undefined : json['localLeadRrp'],
        'localLeadLp': json['localLeadLp'] == null ? undefined : json['localLeadLp'],
        'localLeadRm': json['localLeadRm'] == null ? undefined : json['localLeadRm'],
        'localLeadVat': json['localLeadVat'] == null ? undefined : json['localLeadVat'],
        'localLeadFunctionalDiscount': json['localLeadFunctionalDiscount'] == null ? undefined : json['localLeadFunctionalDiscount'],
        'localLeadSalesDiscount': json['localLeadSalesDiscount'] == null ? undefined : json['localLeadSalesDiscount'],
        'localLeadTradeContributionDiscount': json['localLeadTradeContributionDiscount'] == null ? undefined : json['localLeadTradeContributionDiscount'],
        'globalLeadRrp': json['globalLeadRrp'] == null ? undefined : json['globalLeadRrp'],
        'globalLeadLp': json['globalLeadLp'] == null ? undefined : json['globalLeadLp'],
        'globalLeadRm': json['globalLeadRm'] == null ? undefined : json['globalLeadRm'],
        'globalLeadVat': json['globalLeadVat'] == null ? undefined : json['globalLeadVat'],
        'globalLeadFunctionalDiscount': json['globalLeadFunctionalDiscount'] == null ? undefined : json['globalLeadFunctionalDiscount'],
        'globalLeadSalesDiscount': json['globalLeadSalesDiscount'] == null ? undefined : json['globalLeadSalesDiscount'],
        'globalLeadTradeContributionDiscount': json['globalLeadTradeContributionDiscount'] == null ? undefined : json['globalLeadTradeContributionDiscount'],
        'listPriceFmcTargetFactor': json['listPriceFmcTargetFactor'] == null ? undefined : json['listPriceFmcTargetFactor'],
        'aboveThresholdMin': json['aboveThresholdMin'] == null ? undefined : json['aboveThresholdMin'],
        'aboveThresholdMax': json['aboveThresholdMax'] == null ? undefined : json['aboveThresholdMax'],
        'belowThresholdMin': json['belowThresholdMin'] == null ? undefined : json['belowThresholdMin'],
        'belowThresholdMax': json['belowThresholdMax'] == null ? undefined : json['belowThresholdMax'],
        'thresholdPrice': json['thresholdPrice'] == null ? undefined : json['thresholdPrice'],
        'forecastedDemand': json['forecastedDemand'] == null ? undefined : json['forecastedDemand'],
        'fmcCostPerPiece': json['fmcCostPerPiece'] == null ? undefined : json['fmcCostPerPiece'],
        'productGroupId': json['productGroupId'] == null ? undefined : json['productGroupId'],
        'productGroupName': json['productGroupName'] == null ? undefined : json['productGroupName'],
        'productCategoryId': json['productCategoryId'] == null ? undefined : json['productCategoryId'],
        'productCategoryName': json['productCategoryName'] == null ? undefined : json['productCategoryName'],
        'developmentOwnershipId': json['developmentOwnershipId'] == null ? undefined : json['developmentOwnershipId'],
        'developmentOwnershipName': json['developmentOwnershipName'] == null ? undefined : json['developmentOwnershipName'],
        'productCompositionId': json['productCompositionId'] == null ? undefined : json['productCompositionId'],
        'productCompositionName': json['productCompositionName'] == null ? undefined : json['productCompositionName'],
        'superSegmentId': json['superSegmentId'] == null ? undefined : json['superSegmentId'],
        'superSegmentName': json['superSegmentName'] == null ? undefined : json['superSegmentName'],
        'themeCategoryId': json['themeCategoryId'] == null ? undefined : json['themeCategoryId'],
        'themeCategoryIdAsString': json['themeCategoryIdAsString'],
        'themeCategoryName': json['themeCategoryName'] == null ? undefined : json['themeCategoryName'],
        'isRareItem': json['isRareItem'] == null ? undefined : json['isRareItem'],
        'localLaunchDate': json['localLaunchDate'] == null ? undefined : (new Date(json['localLaunchDate'])),
        'localExitDate': json['localExitDate'] == null ? undefined : (new Date(json['localExitDate'])),
        'dominantMaterialId': json['dominantMaterialId'] == null ? undefined : json['dominantMaterialId'],
        'boxSizeId': json['boxSizeId'] == null ? undefined : json['boxSizeId'],
        'boxSizeName': json['boxSizeName'] == null ? undefined : json['boxSizeName'],
        'businessToBusinessLaunchDate': json['businessToBusinessLaunchDate'] == null ? undefined : (new Date(json['businessToBusinessLaunchDate'])),
        'directToConsumerLifelong': json['directToConsumerLifelong'] == null ? undefined : json['directToConsumerLifelong'],
        'sizeDimension': json['sizeDimension'] == null ? undefined : json['sizeDimension'],
        'pieceCount': json['pieceCount'] == null ? undefined : json['pieceCount'],
        'smartPlayId': json['smartPlayId'] == null ? undefined : json['smartPlayId'],
        'smartPlayName': json['smartPlayName'] == null ? undefined : json['smartPlayName'],
        'playTypeId': json['playTypeId'] == null ? undefined : json['playTypeId'],
        'playTypeName': json['playTypeName'] == null ? undefined : json['playTypeName'],
        'topThemeId': json['topThemeId'] == null ? undefined : json['topThemeId'],
        'topThemeName': json['topThemeName'] == null ? undefined : json['topThemeName'],
        'valueBasedPrice': json['valueBasedPrice'] == null ? undefined : json['valueBasedPrice'],
        'previousValidFrom': json['previousValidFrom'] == null ? undefined : json['previousValidFrom'],
        'previousRrp': json['previousRrp'] == null ? undefined : json['previousRrp'],
        'previousLp': json['previousLp'] == null ? undefined : json['previousLp'],
        'previousRm': json['previousRm'] == null ? undefined : json['previousRm'],
        'previousVat': json['previousVat'] == null ? undefined : json['previousVat'],
        'previousLocalLeadRrp': json['previousLocalLeadRrp'] == null ? undefined : json['previousLocalLeadRrp'],
        'previousLocalLeadLp': json['previousLocalLeadLp'] == null ? undefined : json['previousLocalLeadLp'],
        'previousLocalLeadRm': json['previousLocalLeadRm'] == null ? undefined : json['previousLocalLeadRm'],
        'previousLocalLeadVat': json['previousLocalLeadVat'] == null ? undefined : json['previousLocalLeadVat'],
        'previousGlobalLeadRrp': json['previousGlobalLeadRrp'] == null ? undefined : json['previousGlobalLeadRrp'],
        'previousGlobalLeadLp': json['previousGlobalLeadLp'] == null ? undefined : json['previousGlobalLeadLp'],
        'previousGlobalLeadRm': json['previousGlobalLeadRm'] == null ? undefined : json['previousGlobalLeadRm'],
        'previousGlobalLeadVat': json['previousGlobalLeadVat'] == null ? undefined : json['previousGlobalLeadVat'],
        'previousLocalLeadCurrencyRate': json['previousLocalLeadCurrencyRate'] == null ? undefined : json['previousLocalLeadCurrencyRate'],
        'previousGlobalLeadCurrencyRate': json['previousGlobalLeadCurrencyRate'] == null ? undefined : json['previousGlobalLeadCurrencyRate'],
        'previousForecastedDemand': json['previousForecastedDemand'] == null ? undefined : json['previousForecastedDemand'],
        'previousFmcCostPerPiece': json['previousFmcCostPerPiece'] == null ? undefined : json['previousFmcCostPerPiece'],
        'previousFunctionalDiscount': json['previousFunctionalDiscount'] == null ? undefined : json['previousFunctionalDiscount'],
        'previousSalesDiscount': json['previousSalesDiscount'] == null ? undefined : json['previousSalesDiscount'],
        'previousTradeContributionDiscount': json['previousTradeContributionDiscount'] == null ? undefined : json['previousTradeContributionDiscount'],
        'previousLocalLeadFunctionalDiscount': json['previousLocalLeadFunctionalDiscount'] == null ? undefined : json['previousLocalLeadFunctionalDiscount'],
        'previousLocalLeadSalesDiscount': json['previousLocalLeadSalesDiscount'] == null ? undefined : json['previousLocalLeadSalesDiscount'],
        'previousLocalLeadTradeContributionDiscount': json['previousLocalLeadTradeContributionDiscount'] == null ? undefined : json['previousLocalLeadTradeContributionDiscount'],
        'previousGlobalLeadFunctionalDiscount': json['previousGlobalLeadFunctionalDiscount'] == null ? undefined : json['previousGlobalLeadFunctionalDiscount'],
        'previousGlobalLeadSalesDiscount': json['previousGlobalLeadSalesDiscount'] == null ? undefined : json['previousGlobalLeadSalesDiscount'],
        'previousGlobalLeadTradeContributionDiscount': json['previousGlobalLeadTradeContributionDiscount'] == null ? undefined : json['previousGlobalLeadTradeContributionDiscount'],
        'futureValidFrom': json['futureValidFrom'] == null ? undefined : json['futureValidFrom'],
        'futureRrp': json['futureRrp'] == null ? undefined : json['futureRrp'],
        'futureLp': json['futureLp'] == null ? undefined : json['futureLp'],
        'futureRm': json['futureRm'] == null ? undefined : json['futureRm'],
        'futureVat': json['futureVat'] == null ? undefined : json['futureVat'],
        'nearestFutureModifiedLp': json['nearestFutureModifiedLp'] == null ? undefined : json['nearestFutureModifiedLp'],
        'nearestFutureModifiedLpValidFrom': json['nearestFutureModifiedLpValidFrom'] == null ? undefined : (new Date(json['nearestFutureModifiedLpValidFrom'])),
        'initialRrp': json['initialRrp'] == null ? undefined : json['initialRrp'],
        'initialLp': json['initialLp'] == null ? undefined : json['initialLp'],
        'initialRm': json['initialRm'] == null ? undefined : json['initialRm'],
        'versionRrp': json['versionRrp'] == null ? undefined : json['versionRrp'],
        'versionLp': json['versionLp'] == null ? undefined : json['versionLp'],
        'versionRm': json['versionRm'] == null ? undefined : json['versionRm'],
        'useRrp': json['useRrp'] == null ? undefined : json['useRrp'],
    };
}

export function SimulationDataToJSON(json: any): SimulationData {
    return SimulationDataToJSONTyped(json, false);
}

export function SimulationDataToJSONTyped(value?: Omit<SimulationData, 'themeIdAsString'|'groupIdAsString'|'themeCategoryIdAsString'> | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'primaryKey': value['primaryKey'],
        'planningDate': value['planningDate'],
        'plannedYear': value['plannedYear'],
        'priceUnitId': value['priceUnitId'],
        'productId': value['productId'],
        'productName': value['productName'],
        'license': value['license'],
        'themeId': value['themeId'],
        'themeName': value['themeName'],
        'groupId': value['groupId'],
        'groupName': value['groupName'],
        'productClassLevelOneId': value['productClassLevelOneId'],
        'productClassLevelOneName': value['productClassLevelOneName'],
        'productClassLevelTwoId': value['productClassLevelTwoId'],
        'productClassLevelTwoName': value['productClassLevelTwoName'],
        'productAudience': value['productAudience'],
        'launchStatus': LaunchStatusHyToJSON(value['launchStatus']),
        'currency': value['currency'],
        'currencyDecimals': value['currencyDecimals'],
        'localLeadCurrency': value['localLeadCurrency'],
        'localLeadCurrencyDecimals': value['localLeadCurrencyDecimals'],
        'globalLeadCurrency': value['globalLeadCurrency'],
        'globalLeadCurrencyDecimals': value['globalLeadCurrencyDecimals'],
        'globalLeadIer': value['globalLeadIer'],
        'comment': value['comment'],
        'priceStatus': PriceStatusToJSON(value['priceStatus']),
        'rrp': value['rrp'],
        'lp': value['lp'],
        'rm': value['rm'],
        'vat': value['vat'],
        'functionalDiscount': value['functionalDiscount'],
        'salesDiscount': value['salesDiscount'],
        'tradeContributionDiscount': value['tradeContributionDiscount'],
        'localLeadCurrencyRate': value['localLeadCurrencyRate'],
        'globalLeadCurrencyRate': value['globalLeadCurrencyRate'],
        'localLeadRrp': value['localLeadRrp'],
        'localLeadLp': value['localLeadLp'],
        'localLeadRm': value['localLeadRm'],
        'localLeadVat': value['localLeadVat'],
        'localLeadFunctionalDiscount': value['localLeadFunctionalDiscount'],
        'localLeadSalesDiscount': value['localLeadSalesDiscount'],
        'localLeadTradeContributionDiscount': value['localLeadTradeContributionDiscount'],
        'globalLeadRrp': value['globalLeadRrp'],
        'globalLeadLp': value['globalLeadLp'],
        'globalLeadRm': value['globalLeadRm'],
        'globalLeadVat': value['globalLeadVat'],
        'globalLeadFunctionalDiscount': value['globalLeadFunctionalDiscount'],
        'globalLeadSalesDiscount': value['globalLeadSalesDiscount'],
        'globalLeadTradeContributionDiscount': value['globalLeadTradeContributionDiscount'],
        'listPriceFmcTargetFactor': value['listPriceFmcTargetFactor'],
        'aboveThresholdMin': value['aboveThresholdMin'],
        'aboveThresholdMax': value['aboveThresholdMax'],
        'belowThresholdMin': value['belowThresholdMin'],
        'belowThresholdMax': value['belowThresholdMax'],
        'thresholdPrice': value['thresholdPrice'],
        'forecastedDemand': value['forecastedDemand'],
        'fmcCostPerPiece': value['fmcCostPerPiece'],
        'productGroupId': value['productGroupId'],
        'productGroupName': value['productGroupName'],
        'productCategoryId': value['productCategoryId'],
        'productCategoryName': value['productCategoryName'],
        'developmentOwnershipId': value['developmentOwnershipId'],
        'developmentOwnershipName': value['developmentOwnershipName'],
        'productCompositionId': value['productCompositionId'],
        'productCompositionName': value['productCompositionName'],
        'superSegmentId': value['superSegmentId'],
        'superSegmentName': value['superSegmentName'],
        'themeCategoryId': value['themeCategoryId'],
        'themeCategoryName': value['themeCategoryName'],
        'isRareItem': value['isRareItem'],
        'localLaunchDate': value['localLaunchDate'] == null ? undefined : ((value['localLaunchDate'] as any).toISOString()),
        'localExitDate': value['localExitDate'] == null ? undefined : ((value['localExitDate'] as any).toISOString()),
        'dominantMaterialId': value['dominantMaterialId'],
        'boxSizeId': value['boxSizeId'],
        'boxSizeName': value['boxSizeName'],
        'businessToBusinessLaunchDate': value['businessToBusinessLaunchDate'] == null ? undefined : (formatDateOnly(value['businessToBusinessLaunchDate'] as any)),
        'directToConsumerLifelong': value['directToConsumerLifelong'],
        'sizeDimension': value['sizeDimension'],
        'pieceCount': value['pieceCount'],
        'smartPlayId': value['smartPlayId'],
        'smartPlayName': value['smartPlayName'],
        'playTypeId': value['playTypeId'],
        'playTypeName': value['playTypeName'],
        'topThemeId': value['topThemeId'],
        'topThemeName': value['topThemeName'],
        'valueBasedPrice': value['valueBasedPrice'],
        'previousValidFrom': value['previousValidFrom'],
        'previousRrp': value['previousRrp'],
        'previousLp': value['previousLp'],
        'previousRm': value['previousRm'],
        'previousVat': value['previousVat'],
        'previousLocalLeadRrp': value['previousLocalLeadRrp'],
        'previousLocalLeadLp': value['previousLocalLeadLp'],
        'previousLocalLeadRm': value['previousLocalLeadRm'],
        'previousLocalLeadVat': value['previousLocalLeadVat'],
        'previousGlobalLeadRrp': value['previousGlobalLeadRrp'],
        'previousGlobalLeadLp': value['previousGlobalLeadLp'],
        'previousGlobalLeadRm': value['previousGlobalLeadRm'],
        'previousGlobalLeadVat': value['previousGlobalLeadVat'],
        'previousLocalLeadCurrencyRate': value['previousLocalLeadCurrencyRate'],
        'previousGlobalLeadCurrencyRate': value['previousGlobalLeadCurrencyRate'],
        'previousForecastedDemand': value['previousForecastedDemand'],
        'previousFmcCostPerPiece': value['previousFmcCostPerPiece'],
        'previousFunctionalDiscount': value['previousFunctionalDiscount'],
        'previousSalesDiscount': value['previousSalesDiscount'],
        'previousTradeContributionDiscount': value['previousTradeContributionDiscount'],
        'previousLocalLeadFunctionalDiscount': value['previousLocalLeadFunctionalDiscount'],
        'previousLocalLeadSalesDiscount': value['previousLocalLeadSalesDiscount'],
        'previousLocalLeadTradeContributionDiscount': value['previousLocalLeadTradeContributionDiscount'],
        'previousGlobalLeadFunctionalDiscount': value['previousGlobalLeadFunctionalDiscount'],
        'previousGlobalLeadSalesDiscount': value['previousGlobalLeadSalesDiscount'],
        'previousGlobalLeadTradeContributionDiscount': value['previousGlobalLeadTradeContributionDiscount'],
        'futureValidFrom': value['futureValidFrom'],
        'futureRrp': value['futureRrp'],
        'futureLp': value['futureLp'],
        'futureRm': value['futureRm'],
        'futureVat': value['futureVat'],
        'nearestFutureModifiedLp': value['nearestFutureModifiedLp'],
        'nearestFutureModifiedLpValidFrom': value['nearestFutureModifiedLpValidFrom'] == null ? undefined : (formatDateOnly(value['nearestFutureModifiedLpValidFrom'] as any)),
        'initialRrp': value['initialRrp'],
        'initialLp': value['initialLp'],
        'initialRm': value['initialRm'],
        'versionRrp': value['versionRrp'],
        'versionLp': value['versionLp'],
        'versionRm': value['versionRm'],
        'useRrp': value['useRrp'],
    };
}

